import { render, staticRenderFns } from "./ClavesPresupuestalesTable.vue?vue&type=template&id=1cc08090&scoped=true&"
import script from "./ClavesPresupuestalesTable.vue?vue&type=script&lang=js&"
export * from "./ClavesPresupuestalesTable.vue?vue&type=script&lang=js&"
import style0 from "./ClavesPresupuestalesTable.vue?vue&type=style&index=0&id=1cc08090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc08090",
  null
  
)

export default component.exports